import React from "react";
import PropTypes from "prop-types";
import { Link } from "react-router-dom";
import map from "lodash.map";
import { RouteUrls } from "../configs/routeUrls";

export const Breadcrumb = ({ items, ...props }) => (
  <div className="breadcrumb-shadow">
    <div className="breadcrumb container">
      <ol className="breadcrumb__list">
        <li className="breadcrumb-list__item">
          <Link className="link" to={RouteUrls.App.main}>
            Strona główna
          </Link>
          <span aria-hidden="true" />
        </li>
        {map(items, (breadcrumb, index) => (
          <li
            key={`breadcrumb-list__item-${index}`}
            className="breadcrumb-list__item"
          >
            <Link className="link" to={breadcrumb.url}>
              {breadcrumb.displayName}
            </Link>
            <span aria-hidden="true" />
          </li>
        ))}
      </ol>
    </div>
  </div>
);

Breadcrumb.propTypes = {
  items: PropTypes.arrayOf(
    PropTypes.shape({
      url: PropTypes.string,
      displayName: PropTypes.string,
    }),
  ),
};

Breadcrumb.defaultProps = {
  items: [],
};

// <Container>
// <Navbar collapseOnSelect expand="lg" variant="light" className="navbar bg-light justify-content-between">
//   <NavbarBrand className="navbar-brand col-sm-3 col-md-2 mr-0" to={RouteUrls.App.main}>Logotyp </NavbarBrand>
//   <Nav className="justify-content-end">
// 	<NavItem className="text-nowrap">
// 		{ this.props.isAuth == false && (<NavLink className="nav-link" to={RouteUrls.App.login}>
// 		  Zaloguj
// 		</NavLink>
// 		)}
// 		{this.props.isAuth && (<NavDropdown title={this.props.loginName} id="basic-nav-dropdown">
// 			<NavDropdown.Item href="/ustawienia-konta">Ustawienia konta</NavDropdown.Item>
// 			<NavDropdown.Divider />
// 			<NavDropdown.Item href="/wyloguj">Wyloguj</NavDropdown.Item>
// 		  </NavDropdown>
// 		)}
// 	</NavItem>
//   </Nav>
// </Navbar>
// </Container>
